module.exports = __webpack_public_path__ + "img/iys_is_ortagi_modeli.16c4979d.png";